// extracted by mini-css-extract-plugin
export default {"popup-root":"CommonPopup_popup-root__7lJdO","popup-content":"CommonPopup_popup-content__94t8M","active":"CommonPopup_active__0VqqJ"};